import React from 'react';
import AgencyTemplate from '../components/AgencyTemplate';

const WasteTreating = () => {
	const agencyData = {
		title: "Hazardous and Low-Hazardous Waste Treating",
		subtitle: "Petrochoice Exclusive Agent for Tasminia",
		description: "Petrochoice is an Exclusive agent for Tasminia which deliver innovative bioremediation solutions for treating both hazardous and non-hazardous waste generated by oilfield and industrial activities. Using environmentally friendly and effective technologies, we help clients minimise environmental impact, meet regulatory requirements, and achieve their HSE and sustainability goals. Tasnimia co. have own production of its chemicals for remove hydrocarbons from soil, water and multiple surfaces.",
		image: "/assets/Tasminia.png",
		imageAlt: "Tasminia logo",
		features: [
			{
				title: "C-Clenz – Eco-Friendly Oil Spill Solution",
				description: "C-Clenz is an eco-friendly, biodegradable, and non-hazardous product designed to efficiently remove hydrocarbons from soil, water, and multiple surfaces — delivering results immediately after application.",
				icon: "bi bi-droplet",
				iconColor: "#0c61c0",
				benefits: [
					{ icon: "bi bi-lightning-charge", iconColor: "#ffc107", text: "Fast-acting: Removes crude oil from water on contact; foam remains active for up to an hour" },
					{ icon: "bi bi-activity", iconColor: "#28a745", text: "Bioremediation-friendly: Supports natural hydrocarbon-degrading microbes" },
					{ icon: "bi bi-water", iconColor: "#007bff", text: "Versatile: Effective in both fresh and saltwater, on all oil types" },
					{ icon: "bi bi-shield-check", iconColor: "#28a745", text: "Safe: Non-toxic to humans, animals, plants, and marine life" },
					{ icon: "bi bi-recycle", iconColor: "#28a745", text: "Sustainable: 100% biodegradable with a 5-year shelf life" }
				]
			},
			{
				title: "S-Oil Purge – Advanced Bio-Remediation",
				description: "S-Oil Purge is an eco-friendly, fast-acting solution for eliminating hydrocarbons from soil, water, and hard surfaces. Using surface and interfacial nanoscience, it accelerates natural biostimulation and bioremediation, leaving contaminated areas clean and oil-free.",
				icon: "bi bi-shield-check",
				iconColor: "#28a745",
				benefits: [
					{ icon: "bi bi-rocket-takeoff", iconColor: "#007bff", text: "Immediate Action – Begins breaking down hydrocarbons on contact" },
					{ icon: "bi bi-trash", iconColor: "#dc3545", text: "No Disposal Needed – No skimmers, vacuum trucks, or soil excavation" },
					{ icon: "bi bi-map", iconColor: "#6c757d", text: "Versatile Application – Pavements, gravel, docks, mangroves, boats, shorelines" },
					{ icon: "bi bi-bug", iconColor: "#28a745", text: "Natural Microbe Support – Stimulates indigenous micro-organisms" },
					{ icon: "bi bi-spray-can", iconColor: "#17a2b8", text: "Simple & Effective – Spray-on with stable microscopic droplets" },
					{ icon: "bi bi-shield-lock", iconColor: "#28a745", text: "100% Safe – No lab-grown bacteria, no daily watering, no tilling" }
				]
			}
		],
		additionalSections: [
			{
				title: "Metal Medic",
				content: "The composition of the product provides a sulphide precipitate when mixed into the soil reacts immediately with other heavy metals and will form a less soluble and non-toxic metal sulfides. The resulting heavy metals will be below detectable levels and meet USA EPA Standards for leaching."
			}
		]
	};

	return <AgencyTemplate {...agencyData} />;
};

export default WasteTreating;
